import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { SvgIconComponent } from "@shared/components/svg-icons/svg-icons.component";

@Component({
  selector: "app-title-pj",
  standalone: true,
  imports: [CommonModule, TranslateModule, SvgIconComponent],
  templateUrl: "./title-pj.component.html",
})
export class TitlePjComponent {
  @Input() colorLogo!: string;
  @Input() bgLogo!: string;
}
